import { render } from "./Bandeiras.vue?vue&type=template&id=bc7057c4&scoped=true&ts=true"
import script from "./Bandeiras.vue?vue&type=script&lang=ts"
export * from "./Bandeiras.vue?vue&type=script&lang=ts"

import "./Bandeiras.vue?vue&type=style&index=0&id=bc7057c4&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc7057c4"]])

export default __exports__